const $ = require('jquery');

const updateProfile = function () {
  $('.profile__personal-data_save-btn button').on('click', function() {
    const name = $('[name="name"]').val();
    const lastName = $('[name="last_name"]').val();
    const login = $('[name="login"]').val();
    const email = $('[name="email"]').val();
    const birthday = $('[name="birthday"]').val();
    const gender = $('[name="gender"]').val();
    const unsubscribeTypes = [];

    $('[id^="unsubscribe_type_"]').each(function () {
      const id = $(this).attr('id');
      const index = id.replace('unsubscribe_type_', '');
      if (!$(this).is(':checked')) {
        unsubscribeTypes.push(parseInt(index, 10));
      }
    });

    $.ajax({
      type: 'POST',
      url: '/account/profile_update',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      data: {
        name: name,
        last_name: lastName,
        login: login,
        email: email,
        birthday: birthday,
        gender: gender,
        unsubscribe_types: unsubscribeTypes
      },
      success: function(response) {
        $('.mtui-text-field__error-label').hide();
        $('.mtui-text-field__wrapper').removeClass('mtui-text-field_error');

        const updatedName = `${response.name} ${response.last_name.charAt(0)}`
        $('.auth__name').text(updatedName);
        $('#success_window').removeClass('message-hidden');
        setTimeout(function() {
          $('#success_window').addClass('message-hidden');
        }, 5000);
      },
      error: function(error) {
        if (error.responseJSON && error.responseJSON.errors) {
          let errors = error.responseJSON.errors;
          Object.keys(errors).forEach(function(field) {
            let errorMessage = errors[field][0];
            addError($(`#${field}`), errorMessage);
          });
        }
        $('#error_window').removeClass('message-hidden');
        setTimeout(function() {
          $('#error_window').addClass('message-hidden');
        }, 5000);
      }
    });
  });
}

function addError($input, error) {
  let $wrapper = $input.closest('.mtui-text-field__wrapper');
  $wrapper.find('.mtui-text-field__error-label').show();
  $wrapper.addClass('mtui-text-field_error');
  if (error) {
    $wrapper.find('.mtui-text-field__error-label').text(error);
  } else {
    $wrapper.find('.mtui-text-field__error-label').text("Произошла ошибка");
  }
}

export {updateProfile}
